import { AddressModel, IfcAddressDescription, IfcAddressProperties, StringPropertyDescription } from 'models';

export function addressToIlpAddress(address: AddressModel | null, ifcAddressQuestionSet: IfcAddressDescription): any {
    let result = {};

    result[ifcAddressQuestionSet.properties.subPropertyNumber.name] = address?.flat ?? '';
    result[ifcAddressQuestionSet.properties.name.name] = address?.building ?? '';
    result[ifcAddressQuestionSet.properties.number.name] = address?.number ?? '';
    result[ifcAddressQuestionSet.properties.street.name] = address?.street ?? '';
    result[ifcAddressQuestionSet.properties.town.name] = address?.town ?? '';
    result[ifcAddressQuestionSet.properties.county.name] = address?.county ?? '';
    result[ifcAddressQuestionSet.properties.postCode.name] = address?.postcode?.code ?? '';

    return result;
}

export function ilpAddressToAddress(ilpAddress: any, ifcAddressQuestionSet: IfcAddressDescription): AddressModel {
    return new AddressModel(
        ilpAddress[ifcAddressQuestionSet.properties.subPropertyNumber.name],
        ilpAddress[ifcAddressQuestionSet.properties.name.name],
        ilpAddress[ifcAddressQuestionSet.properties.number.name],
        ilpAddress[ifcAddressQuestionSet.properties.street.name],
        ilpAddress[ifcAddressQuestionSet.properties.town.name],
        null,
        ilpAddress[ifcAddressQuestionSet.properties.county.name],
        ilpAddress[ifcAddressQuestionSet.properties.postCode.name],
    );
}

export function getIfcPropertyForControl(properties: Record<keyof IfcAddressProperties, StringPropertyDescription>, controlName: string): StringPropertyDescription {
    let propertyDescription = null;

    switch (controlName) {
        case 'flat':
            propertyDescription = properties.subPropertyNumber;
            break;
        case 'buildingName':
            propertyDescription = properties.name;
            break;
        case 'houseNumber':
            propertyDescription = properties.number;
            break;
        case 'street':
            propertyDescription = properties.street;
            break;
        case 'town':
            propertyDescription = properties.town;
            break;
        case 'county':
            propertyDescription = properties.county;
            break;
        case 'postcode':
            propertyDescription = properties.postCode;
            break;
    }

    return propertyDescription as StringPropertyDescription;
}

export function isMobilePhoneNumber(phoneNumber: string): boolean {
    const UK_MOBILE_START_CODE = '07';

    return phoneNumber.startsWith(UK_MOBILE_START_CODE);
}